import { authMiddleware } from '@/router/middleware/authMiddleware'
import { roleMiddleware } from '@/router/middleware/roleMiddleware'
import RolesHelper from '@/helpers/Roles'
// import EditorMenuConfig from '@/config/EditorMenuConfig'

const editor = [
    {
        path: '/editor',
        // component: () => import('@/components/Layout/EditorLayout.vue'),
        // props: {
        //     menu: EditorMenuConfig,
        // },
        beforeEnter: [
            authMiddleware,
            roleMiddleware,
        ],
        meta: {
            authorize: [RolesHelper.Roles.Editor],
        },
        children: [
            {
                path: 'dashboard',
                name: 'editor-dashboard',
                component: () => import('@/views/Editor/Dashboard.vue'),
            },
        ],
    },
]

export default editor